"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonthPicker = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const date_picker_1 = tslib_1.__importDefault(require("antd/es/date-picker"));
const { MonthPicker: AntdMonthPicker } = date_picker_1.default;
exports.MonthPicker = (_a) => {
    var { className = '' } = _a, rest = tslib_1.__rest(_a, ["className"]);
    return React.createElement(AntdMonthPicker, Object.assign({ dropdownClassName: 'clp-datepicker', className: `clp-datepicker__input ${className}` }, rest));
};
//# sourceMappingURL=MonthPicker.js.map